'use es6';

import { Record, Map as ImmutableMap } from 'immutable';
import LoginRecommend from '../constants/LoginRecommend';
const LoginRequirementRecord = Record({
  loginRequirement: ImmutableMap({
    loginType: LoginRecommend.HUBSPOT,
    hardRequirement: false
  }),
  hasSsoRequirement: false,
  stagedEmail: '',
  stagedRememberLogin: false,
  useDark: false,
  loginRedirectUrl: undefined,
  allowFbSignup: false,
  hideSignupLink: false,
  signupParams: undefined,
  loginPortalId: undefined,
  pageId: undefined
}, 'RecommendedLoginFlowRecord');

const validateRecomendedResponse = (response, data, queryData) => {
  return LoginRequirementRecord(Object.assign({}, response, {
    stagedEmail: data.email,
    stagedRememberLogin: data.rememberLogin
  }, queryData));
};

export default validateRecomendedResponse;